module.exports = __webpack_public_path__ + "static/media/bridge.429fc6df.jpg";